import { AuthContextProvider } from './auth'
import Router from './Router'
import { ConfigProvider, App as AntApp } from 'antd'

const theme = {
  token: {
    colorPrimary: '#475254',
    colorLink: '#009EDC',
    colorInfo: '#009EDC',
    colorSuccess: '#33754B',
    colorWarning: '#009EDC',
    colorError: '#D3222A',
    colorText: '#475254',
    colorTextSecondary: '#6D6D6D',
    colorBorder: '#CCCCCC',
    borderRadius: 4,
    colorBgContainer: '#FFFFFF',
    colorBgLayout: '#F2F2F2',
    fontFamily: "'trade-gothic-next', 'Barlow'",
    fontFamilyCode: "'trade-gothic-next', 'Barlow'",
    fontSize: 16,
    lineHeight: 1.5,
    fontSizeSM: 14,
    lineHeightSM: 20 / 14,
  },
}

function App () {
  return (
    <ConfigProvider theme={theme}>
      <AntApp>
        <AuthContextProvider>
          <Router />
        </AuthContextProvider>
      </AntApp>
    </ConfigProvider>
  )
}

export default App
